// extracted by mini-css-extract-plugin
export default {"bolded":"style--bolded--45b3c2"};